import { PropsWithChildren } from "react";
import { PropsWithClassName } from "@/shared/types/utils";
import { cn } from "@/shared/utils";

export const Subtitle = (props: PropsWithClassName<PropsWithChildren>) => (
  <p
    className={cn(
      props.className,
      "text-[#7B7B87] text-base leading-6 lg:text-xl lg:leading-7"
    )}
  >
    {props.children}
  </p>
);
